/** Vier ruhige Linienzeichnungen (120 × 96), über Tokens gefärbt; dekorativ, für Screenreader versteckt. */
export type IllustrationName = "empty-shelf" | "sold" | "return-box" | "all-done";

const BILDER: Record<IllustrationName, React.ReactNode> = {
  "empty-shelf": (
    <>
      <rect x="18" y="14" width="84" height="70" rx="6" className="i-soft" />
      <path d="M24 34h72M24 54h72M24 74h72" className="i-line" />
      <path d="M30 14v70M90 14v70" className="i-line" />
      <path d="M40 46h14M66 26h12" className="i-dash" />
    </>
  ),
  sold: (
    <>
      <circle cx="60" cy="48" r="34" className="i-amber" />
      <path d="M44 48l11 11 21-22" className="i-ink-line" />
      <path d="M14 20l6 6M106 20l-6 6M20 78l6-6M100 78l-6-6" className="i-amber-line" />
    </>
  ),
  "return-box": (
    <>
      <path d="M22 40l38-16 38 16v34l-38 16-38-16z" className="i-soft" />
      <path d="M22 40l38 16 38-16M60 56v34" className="i-line" />
      <path d="M40 32l38 16" className="i-dash" />
      <circle cx="94" cy="24" r="10" className="i-amber" />
      <path d="M90 24l3 3 5-6" className="i-ink-line" />
    </>
  ),
  "all-done": (
    <>
      <circle cx="60" cy="48" r="34" className="i-ok" />
      <path d="M44 49l11 11 21-22" className="i-ok-line" />
      <path d="M18 26h10M92 70h10M24 72h6M96 22h6" className="i-petrol-line" />
    </>
  ),
};

export function Illustration({ name, size = 120 }: { name: IllustrationName; size?: number }) {
  return (
    <svg className="rg-illu" width={size} height={(size * 96) / 120} viewBox="0 0 120 96" aria-hidden="true" focusable="false">
      {BILDER[name]}
    </svg>
  );
}
